import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-navigation"
export default class extends Controller {
  static targets = ["trigger", "menu", "slide", "searchRow", "searchInput"]
  static classes = ["on", "fullNavHeight", "finished"]
  static values = {
    onClass: { type: String, default: "is-on" },
    fullNavHeightClass: { type: String, default: "full-nav-height" },
    finishedClass: { type: String, default: "finished" }
  }

  connect() {
    // Initialize if needed
  }

  toggle(event) {
    event.preventDefault()
    
    this.triggerTargets.forEach(el => el.classList.toggle(this.onClassValue))
    this.menuTargets.forEach(el => el.classList.toggle(this.onClassValue))
    this.slideTargets.forEach(el => el.classList.toggle(this.onClassValue))
  }

  open(event) {
    if (this.hasTriggerTarget && !this.triggerTarget.classList.contains(this.onClassValue)) {
      this.triggerTargets.forEach(el => el.classList.add(this.onClassValue))
      this.menuTargets.forEach(el => el.classList.add(this.onClassValue))
      this.slideTargets.forEach(el => el.classList.add(this.onClassValue))
    }
  }

  close(event) {
    // Only close if currently open (checked by presence of class on trigger)
    // Or just remove the class safely
    if (this.hasTriggerTarget && this.triggerTarget.classList.contains(this.onClassValue)) {
      this.triggerTargets.forEach(el => el.classList.remove(this.onClassValue))
      this.menuTargets.forEach(el => el.classList.remove(this.onClassValue))
      this.slideTargets.forEach(el => el.classList.remove(this.onClassValue))
    }
    
    // Also handle resize logic: close the mobile nav if the screen is big.
    // (A document-wide `.collapse.show` sweep used to live here too - vestigial
    // for this nav, which contains no .collapse at all, and it silently stripped
    // `show` from server-rendered collapses elsewhere on the page: the profile
    // rail's subsection panels, #collapseComments on contacts/show, the online
    // dealers visibility panels - desynchronising them from their toggles.)
    if (event.type === 'resize' && window.innerWidth > 1199) {
      this.triggerTargets.forEach(el => el.classList.remove(this.onClassValue))
      this.menuTargets.forEach(el => el.classList.remove(this.onClassValue))
      this.slideTargets.forEach(el => el.classList.remove(this.onClassValue))
    }
  }

  toggleSearch(event) {
    event.preventDefault()
    
    this.searchRowTargets.forEach(el => {
      el.classList.remove(this.finishedClassValue)
      el.classList.toggle(this.fullNavHeightClassValue)
    })
  }

  // Called when transition ends on search row
  searchTransitionEnd(event) {
    // Ensure the event target is the search row itself
    if (!this.searchRowTargets.includes(event.target)) return

    if (event.target.classList.contains(this.fullNavHeightClassValue)) {
      event.target.classList.add(this.finishedClassValue)
      if (this.hasSearchInputTarget) {
        this.searchInputTarget.focus()
      } else {
        // Fallback to finding .toggle-focus inside the row if target not explicitly set
        const input = event.target.querySelector('.toggle-focus')
        if (input) input.focus()
      }
    }
  }
}
